import { LibraryOutlineIcon } from './LibraryOutlineIcon';

/**
 * author: Jeff Anders
 * id 1A100B37-6238-49F0-81EB-05FDE23DAA3E
 * name library-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/library-outline.svg
 * tags
 * - Places 
 */
export const LocalLibraryOutlineIcon = LibraryOutlineIcon;
export default LocalLibraryOutlineIcon